import { render, staticRenderFns } from "./OrgChart.vue?vue&type=template&id=625be21c&"
import script from "./OrgChart.vue?vue&type=script&lang=js&"
export * from "./OrgChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports